import { Box } from "@mui/material"
import type { FC } from "react"
import React from "react"
import { useFormContext } from "react-hook-form"

import { FormDatePicker } from "@/components/UiKit"
import { PriceChangeType } from "@/graphql/codegen/graphql"
import AcceptedCostField from "@/screens/Pricing/components/forms/AcceptedCostField"
import PriceChangeField from "@/screens/Pricing/components/forms/PriceChangeField"

interface PriceChangeBulkOptionsFormProps {
  priceChangeType?: PriceChangeType
}

const PriceChangeBulkOptionsForm: FC<PriceChangeBulkOptionsFormProps> = ({ priceChangeType }) => {
  const { control } = useFormContext()

  return (
    <form>
      <Box className='flex w-full flex-row justify-end'>
        <Box className='flex flex-row gap-3'>
          {priceChangeType === PriceChangeType.SellingPrice && <AcceptedCostField />}

          <PriceChangeField />

          <FormDatePicker
            control={control}
            name='effectiveDate'
            label='Effective Date'
            data-testid='price-change.bulk-update-form.effective-date-field'
          />

          <FormDatePicker
            control={control}
            name='expirationDate'
            label='Expiration Date'
            data-testid='price-change.bulk-update-form.expiration-date-field'
          />
        </Box>
      </Box>
    </form>
  )
}

export default PriceChangeBulkOptionsForm
